export default __webpack_public_path__ + "static/media/fc6_logo_jp.57b0a884.png";